import { useQuery } from "@tanstack/react-query";
import {
  calendarDayQueryKey,
  readCalendarDays,
} from "@/pages/human-resources/time-management/endpoints/CalendarEndpoints.ts";
import type { CalendarDay } from "@/pages/human-resources/time-management/business/calendar/CalendarDay.ts";
import { mapToCalendarDay } from "@/pages/human-resources/time-management/endpoints/calendar/inout/CalendarDayOut.ts";
import showErrorToast from "@/shared/components/generic/snackbar/showErrorToast.ts";
import { useTranslation } from "react-i18next";

export function useReadCalendarDays(
  siteId: string,
  start: Date | undefined,
  end: Date | undefined,
): CalendarDay[] | undefined {
  const { t } = useTranslation(["humanResources"], {
    keyPrefix: "timeManagement",
  });

  const { data } = useQuery({
    queryKey: calendarDayQueryKey.forSiteAndDateRange(siteId, start, end),
    queryFn: async () => {
      try {
        if (start === undefined || end === undefined) return [];
        return await readCalendarDays(siteId, start, end);
      } catch (error) {
        console.error(error);
        showErrorToast(t("errors.backend.calendar.read"));
        return [];
      }
    },
    select: (days) => days.map(mapToCalendarDay),
    throwOnError: false,
  });
  return data;
}
